import {SubtabMenuVo} from '../../common/shared/api/karina/vo/menu/SubtabMenuVo.interface';
import {MenuType, SubtabMenu} from '../generated/types';
import {createScreen} from './Screen';

export function createSubtabMenu(subtabMenuVo: SubtabMenuVo): SubtabMenu {
  return {
    id: `subtabMenu-${subtabMenuVo.uid}`,
    uid: subtabMenuVo.uid,
    title: subtabMenuVo.title,
    type: MenuType.Subtab,
    screenList: subtabMenuVo.screen_list.map(createScreen),
  };
}
